import { render, staticRenderFns } from "./BaseGlobalMessage.vue?vue&type=template&id=41068dd1&"
import script from "./BaseGlobalMessage.vue?vue&type=script&lang=js&"
export * from "./BaseGlobalMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports